import React from 'react';
import { Box } from '@fiverr-private/theme';

interface StatusProps {
    text: string;
}

export function Status({ text }: StatusProps) {
    return (
        <Box
            minHeight="20px"
            display="flex"
            alignItems="center"
            width="fit-content"
            letterSpacing="0.5px"
            fontSize="b_xxs"
            lineHeight="b_xs"
            paddingX="2"
            borderRadius="2xl"
            borderStyle="solid"
            borderWidth="sm"
            borderColor="grey_300"
            color="grey_300"
            fontWeight="bold"
            userSelect="none"
        >
            {text}
        </Box>
    );
}
